export type PeriodKey = "1h" | "24h" | "7d" | "30d" | "custom";

/** `short` is the chip text; `label` the full name (and the chip's accessible name). */
export const PERIODS: Array<{ value: PeriodKey; label: string; short: string; hours: number }> = [
  { value: "1h", label: "Last hour", short: "Last hour", hours: 1 },
  { value: "24h", label: "Last 24 hours", short: "24 hours", hours: 24 },
  { value: "7d", label: "Last 7 days", short: "7 days", hours: 24 * 7 },
  { value: "30d", label: "Last 30 days", short: "30 days", hours: 24 * 30 },
  { value: "custom", label: "Custom", short: "Custom", hours: 0 },
];

/** A `datetime-local` value ("2026-10-09T10:30") for a date, in local time. */
export const toLocalInput = (d: Date) =>
  new Date(d.getTime() - d.getTimezoneOffset() * 60_000).toISOString().slice(0, 16);

/** The ISO start and end of a period ending at `now`; custom reads the two inputs. */
export function periodRange(
  key: PeriodKey,
  now: Date,
  custom: { start: string; end: string },
): { start: string; end: string } | null {
  if (key !== "custom") {
    const hours = PERIODS.find((p) => p.value === key)!.hours;
    return { start: new Date(now.getTime() - hours * 3_600_000).toISOString(), end: now.toISOString() };
  }
  const start = new Date(custom.start);
  const end = new Date(custom.end);
  if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime()) || start >= end) return null;
  return { start: start.toISOString(), end: end.toISOString() };
}
